import { faCheckCircle, faExclamationTriangle, faInfoCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert as AntdAlert } from 'antd';
import { type AlertProps as AntdAlertProps } from 'antd/es/alert';
import cx from 'classnames';
import './styles.scss';
const AlertClass = 'app-alert';
const iconMap = {
  success: {
    icon: faCheckCircle
  },
  info: {
    icon: faInfoCircle
  },
  warning: {
    icon: faExclamationTriangle
  },
  error: {
    icon: faTimesCircle
  }
};
export enum AlertVariant {
  Default = 'default',
  Text = 'text',
}
type AlertVariantType = `${AlertVariant}`;
export type AlertProps = AntdAlertProps & {
  /**
   * Visual variant of the alert.
   * - `default`: Standard alert with background and border
   * - `text`: Text-only alert with no background or border
   * @default 'default'
   */
  variant?: AlertVariantType;
};

/**
 * This function is a wrap around [antd Alert](https://ant.design/components/alert/) component extending some of
 * the properties to follow our styling guidelines.
 *
 * Please refer to antd documentation for more details.
 *
 */

export function Alert({
  className,
  icon,
  type = 'info',
  variant = AlertVariant.Default,
  ...props
}: AlertProps) {
  const iconConfig = iconMap[type];
  const alertIcon = icon ?? <FontAwesomeIcon icon={iconConfig.icon} />;
  return <AntdAlert className={cx(className, AlertClass, {
    [`${AlertClass}--text`]: variant === AlertVariant.Text
  })} icon={alertIcon} type={type} {...props} />;
}
export default Alert;